import { render, staticRenderFns } from "./ViewMyEvents.vue?vue&type=template&id=0c218aca&scoped=true"
import script from "./ViewMyEvents.vue?vue&type=script&lang=js"
export * from "./ViewMyEvents.vue?vue&type=script&lang=js"
import style0 from "./ViewMyEvents.vue?vue&type=style&index=0&id=0c218aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c218aca",
  null
  
)

export default component.exports